export const TrimixWhyDefyMedStepCardData = [
  {
    icon: "/images/icons/icon-rx.svg",
    title: "Full Medical Practice",
    description:
      "Receive care from licensed medical professionals who specialize in Men’s Health.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-prices.svg",
    title: "Unbeatable Prices",
    description:
      "Access affordable medications without compromising on quality. Our pricing is designed to fit your budget.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-syringe.svg",
    title: "Expanded Options",
    description:
      "As experts in the field of Men’s Health, we bring you ED options that other clinics don’t offer.",
    className: "bg-[#f6f7f9]",
  },
];

export const TrimixGeneralStepCardData = [
  {
    icon: "/images/icons/icon-fda.svg",
    title: "",
    description: "Effective medication at a fraction of the cost.",
    className: "bg-white",
  },
  {
    icon: "/images/icons/icon-online-ordering.svg",
    title: "",
    description:
      "Simple online ordering and doorstep delivery in plain packaging.",
    className: "bg-white",
  },
  {
    icon: "/images/icons/icon-shipping.svg",
    title: "",
    description:
      "Free shipping on subscription orders or any orders above $100.",
    className: "bg-white",
  },
];

export const HomeHowItWorksStepCardData = [
  {
    icon: "/images/icons/icon-signup.svg",
    title: "Sign Up",
    description:
      "Answer our questionnaire and find the ED med(s) that fit your needs. A licensed practitioner will review and approve your options.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-order.svg",
    title: "Order Medications",
    description:
      "After practitioner approval, order your medications online and have them shipped discreetly to your door.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-signup.svg",
    title: "Enjoy and Reorder",
    description:
      "Receive your medications and regain your intimacy. Reorder as needed, or sign up for a subscription for regular delivery.",
    className: "bg-[#f6f7f9]",
  },
];

export const OralMedWhyDefyMedStepCardData = [
  {
    icon: "/images/icons/icon-rx.svg",
    title: "Full Medical Practice",
    description:
      "Receive care from licensed medical professionals who specialize in Men’s Health.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-prices.svg",
    title: "Unbeatable Prices",
    description:
      "Access affordable medications without compromising on quality. Our pricing is designed to fit your budget.",
    className: "bg-[#f6f7f9]",
  },
];

export const OralMedGeneralStepCardData = [
  {
    icon: "/images/icons/icon-fda.svg",
    title: "",
    description: "Generic medication at a fraction of the cost.",
    className: "bg-white",
  },
  {
    icon: "/images/icons/icon-online-ordering.svg",
    title: "",
    description:
      "Simple online ordering and doorstep delivery in plain packaging.",
    className: "bg-white",
  },
  {
    icon: "/images/icons/icon-shipping.svg",
    title: "",
    description:
      "Free shipping on subscription orders or any orders above $100.",
    className: "bg-white",
  },
];


export const ProductDetailBenefitStepCardData = [
  {
    icon: "/images/icons/icon-rx.svg",
    title: "Full Medical Practice",
    description:
      "Receive care from licensed medical professionals who specialize in Men’s Health.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-prices.svg",
    title: "Unbeatable Prices",
    description:
      "Access affordable medications without compromising on quality. Our pricing is designed to fit your budget.",
    className: "bg-[#f6f7f9]",
  },
  {
    icon: "/images/icons/icon-syringe.svg",
    title: "Expanded Options",
    description:
      "As experts in the field of Men’s Health, we bring you ED options that other clinics don’t offer.",
    className: "bg-[#f6f7f9]",
  },
];